<div class="auth-page d-flex align-items-center justify-content-center min-vh-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card">
            <div class="card-body p-4">
              <div class="text-center mt-2">
                <h5 class="text-primary">Two-Factor Authentication</h5>
                <p class="text-muted">Enter the verification code from your authenticator app</p>
              </div>
              
              <div class="p-2 mt-4">
                <div class="mb-3">
                  <label for="verificationCode" class="form-label">Verification Code</label>
                  <input type="text" class="form-control" id="verificationCode" 
                    placeholder="Enter 6-digit code" [(ngModel)]="verificationCode" 
                    maxlength="6" pattern="[0-9]*" inputmode="numeric">
                </div>
                
                <div class="mt-3 d-grid">
                  <button class="btn btn-primary" type="button" 
                    [disabled]="isLoading || !verificationCode" 
                    (click)="verifyCode()">
                    Verify
                  </button>
                </div>
                
                <div class="mt-2 text-center">
                  <button class="btn btn-primary" type="button" (click)="cancel()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  